import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { DATA_EXPORT_SCHEMA_CONFIGS_KEY } from './useDataExportSchemaConfigs';

export default function useDeleteDataExportSchemaConfig() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: (configId: string) => api.delete(`/data-export-configs/${configId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: DATA_EXPORT_SCHEMA_CONFIGS_KEY,
      });
    },
  });

  const deleteConfig = async (configId: string) => {
    await mutateAsync(configId);
  };

  return { deleteConfig, isLoading };
}
